"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class PaymentDetails {
}
exports.default = PaymentDetails;
//# sourceMappingURL=PaymentDetails.js.map